import React from 'react';
import { Link } from 'react-router-dom';
import { services } from '../../lib/servicesData';

const Footer = () => (
  <footer className="bg-[#0B202C] text-white">
    <div className="mx-auto max-w-7xl px-6 pb-10 pt-16 lg:px-8 lg:pt-20">
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-[1.25fr_.75fr_.85fr_1fr]">
        <div>
          <Link to="/" className="inline-flex items-center gap-2.5" aria-label="Nexgeius home">
            <img src="/favicon.ico" alt="" width="40" height="40" className="h-10 w-10 object-contain" />
            <span className="text-2xl font-semibold tracking-[-0.04em]">Nexgeius</span>
          </Link>
          <p className="mt-5 max-w-sm text-sm leading-6 text-[#9FB1BA]">A Toronto development studio building websites, custom software, and practical AI automation for growing businesses.</p>
        </div>

        <div>
          <h2 className="text-[11px] font-bold uppercase tracking-[0.18em] text-[#78909B]">Company</h2>
          <ul className="mt-5 space-y-3">
            {[
              ['Work', '/case-studies'],
              ['Pricing', '/pricing'],
              ['Insights', '/insights'],
              ['About', '/about'],
              ['Services', '/services'],
              ['Contact', '/contact'],
            ].map(([label, to]) => <li key={to}><Link to={to} className="text-sm text-[#B8C7CE] hover:text-white">{label}</Link></li>)}
          </ul>
        </div>

        <div>
          <h2 className="text-[11px] font-bold uppercase tracking-[0.18em] text-[#78909B]">Services</h2>
          <ul className="mt-5 space-y-3">
            {services.map((service) => (
              <li key={service.id}><Link to={`/services/${service.id}`} className="text-sm text-[#B8C7CE] hover:text-white">{service.title}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h2 className="text-[11px] font-bold uppercase tracking-[0.18em] text-[#78909B]">Talk to us</h2>
          <div className="mt-5 space-y-3">
            <a href="mailto:nexgeius@gmail.com" className="block text-sm text-[#B8C7CE] hover:text-white">nexgeius@gmail.com</a>
            <p className="text-sm text-[#8297A1]">Toronto, Ontario</p>
          </div>
          <Link to="/contact" className="mt-6 inline-flex items-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-semibold text-[#102A3A] transition hover:-translate-y-0.5">Start a project <span aria-hidden="true">&rarr;</span></Link>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 px-6 py-5 text-xs text-[#78909B] md:flex-row md:items-center md:justify-between lg:px-8">
        <p>&copy; {new Date().getFullYear()} Nexgeius. All rights reserved.</p>
        <div className="flex gap-6">
          <Link to="/privacy-policy" className="hover:text-white">Privacy Policy</Link>
          <Link to="/terms-of-service" className="hover:text-white">Terms of Service</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
